import { HttpClient } from '@angular/common/http';
import { Environment } from '../../shared/environment/environment';
var ApiGatewayService = /** @class */ (function () {
    function ApiGatewayService(httpClient) {
        this.httpClient = httpClient;
    }
    ApiGatewayService.prototype.retrieveJwtToken = function (cpeId) {
        return this.httpClient.get(this.getBaseUrl() + '/jwt-redirect/private/jwt-service', {
            responseType: 'text',
            params: { 'cpeid': cpeId }
        });
    };
    ApiGatewayService.prototype.getBaseUrl = function () {
        return Environment.environmentConfig().baseApiUrl;
    };
    return ApiGatewayService;
}());
export { ApiGatewayService };
